import {
  PERMISSIONS,
  type Permission,
} from "@/lib/auth/rbac-config";
import {
  PERMISSION_SEEDS_WITH_SPA_KEYS,
  permissionCode,
} from "@/seeders/permissions.seed";

/** Maps API permission codes (`resource:action`) to SPA client keys (`view:dashboard`). */
export const SPA_KEY_BY_BACKEND_CODE = new Map<string, Permission>(
  PERMISSION_SEEDS_WITH_SPA_KEYS.flatMap((seed) =>
    seed.spaKey ? [[permissionCode(seed), seed.spaKey] as const] : [],
  ),
);

/** Pre-migration approve/reject codes still grant review UI access until DB is re-seeded. */
const LEGACY_REVIEW_BACKEND_CODES: Record<string, Permission> = {
  "alerts:approve": "review:alerts",
  "alerts:reject": "review:alerts",
  "screenshots:approve": "review:screenshots",
  "screenshots:reject": "review:screenshots",
  "clean_room:read": "view:history",
  "videos:read": "view:history",
  "videos:detail": "view:history",
  "dashboard:activity": "view:dashboard",
  "roles:manage": "view:roles",
  "screenshots:read": "view:screenshots",
};

const SPA_PERMISSION_SET = new Set<string>(PERMISSIONS);

export function isSpaPermissionKey(value: string): value is Permission {
  return SPA_PERMISSION_SET.has(value);
}

export function backendPermissionCode(
  resource: string,
  action: string,
): string {
  return `${resource.trim().toLowerCase()}:${action.trim().toLowerCase()}`;
}

export function spaKeyFromBackendCode(code: string): Permission | null {
  const normalized = code.trim().toLowerCase();
  return (
    LEGACY_REVIEW_BACKEND_CODES[normalized] ??
    SPA_KEY_BY_BACKEND_CODE.get(normalized) ??
    null
  );
}
